import classNames from "classnames";
import React, { FC } from "react";
import { Icon, IconName } from "../icon";

import "./empty-state.css";

interface IEmptyState {
	title: string;
	subtitle: string;
	iconName: IconName;
	className?: string;
}

export const EmptyState: FC<IEmptyState> = ({ iconName, subtitle, title, className, ...rest }) => {
	return (
		<div className={classNames("empty-placeholder", className)} {...rest}>
			<Icon className="empty-placeholder__icon" iconName={iconName} />
			<span className="empty-placeholder__title">{title}</span>
			<span className="empty-placeholder__subtitle">{subtitle}</span>
		</div>
	);
};
